import { render, staticRenderFns } from "./TxtBanner.vue?vue&type=template&id=590b891e&scoped=true&"
import script from "./TxtBanner.vue?vue&type=script&async=true&lang=js&"
export * from "./TxtBanner.vue?vue&type=script&async=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590b891e",
  null
  
)

export default component.exports